import { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";

interface Props {
  /** Payload encoded into the QR (e.g. JSON `{eventId, guestId}` string). */
  value: string;
  size?: number;
  className?: string;
  alt?: string;
}

/**
 * Renders a QR code as an <img>. Generation runs client-side via the qrcode
 * library; we re-render on `value` change.
 */
const QrCodeImage = ({ value, size = 240, className, alt }: Props) => {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const reqId = useRef(0);

  useEffect(() => {
    const id = ++reqId.current;
    void QRCode.toDataURL(value, {
      margin: 1,
      width: size,
      errorCorrectionLevel: "M",
    }).then((url) => {
      if (reqId.current === id) setDataUrl(url);
    });
  }, [value, size]);

  if (!dataUrl) {
    return (
      <div
        className={className ?? "rounded-lg bg-muted"}
        style={{ width: size, height: size }}
        aria-busy
      />
    );
  }
  return (
    <img
      src={dataUrl}
      width={size}
      height={size}
      alt={alt ?? "QR code"}
      className={className ?? "rounded-lg bg-white p-2"}
    />
  );
};

export default QrCodeImage;
